import { read } from "fs";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const surveryAllFields = [
  {
    id: "surveyorId",
    label: "Surveyor",
    placeHolder: "Select",
    type: "select",
    isRequired: true,
    options: [""],
    md: 6,

  },
  {
    id: "surveyType",
    label: "Survey Type",
    placeHolder: "Select",
    type: "select",
    options: ["Video Call", "On Site", "List Provided"],
    isRequired: true,
    md: 6,

  },
  // {
  //   id: "leadId",
  //   label: "Customer Name",
  //   placeHolder: "select",
  //   type: "select",
  //   options: [""],
  //   isRequired: true,
  // },
  {
    id: "customer_name",
    label: "Customer Name",
    placeHolder: "Please Enter customer name",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
    editReadOnly: true,
    md: 12
  },
  // {
  //   id: "surveyDate",
  //   label: "Start Date",
  //   placeHolder: "Enter phone number",
  //   type: "date",
  //   inputProps: {
  //       maxLength: 50,
  //     },
  //     patternAllowed: patternConstant?.ALPHANUMERIC,
  //     isRequired: true,
  // },
  {
    id: "startTime",
    label: "Start Time",
    placeHolder: "Enter start time",
    type: "date-time",
    isRequired: true,
    disablePast: true,
    md: 6
  },
  // {
  //   id: "endDate",
  //   label: "End Date",
  //   placeHolder: "Enter phone number",
  //   type: "date",
  // },
  {
    id: "endTime",
    label: "End Time",
    placeHolder: "Enter end time",
    type: "date-time",
    // isRequired: true,
    md: 6,
    disablePast: true,
  },
  {
    id: "description",
    label: "Description",
    placeHolder: "Enter descriptions",
    type: "textarea",
    inputProps: {
      maxLength: 150,
    },
    editReadOnly: true,
    md: 12,
  },
];

export const surveryEventAllFields = [
  {
    id: "assignTo",
    label: "Assign To",
    placeHolder: "Please Enter customer name",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
    editReadOnly: true,
    disabled:true,
    md: 12
  },
  {
    id: "eventType",
    label: "Event Type",
    placeHolder: "Please Enter event name",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
    readOnly: true,
    disabled:true,
    md: 12
  },
  {
    id: "startDate",
    label: "Start Time",
    placeHolder: "Enter start time",
    type: "date-time",
    isRequired: true,
    disablePast: true,
    md: 12
  },

  {
    id: "endDate",
    label: "End Time",
    placeHolder: "Enter end time",
    type: "date-time",
    // isRequired: true,
    disablePast: true,
    md: 12
  },
];
